import React from "react";
import EPostaLogo from "../../layout/header/ePosta-logo.png";
import DitLogo from "../../layout/footer/dokit-logo.png";
import ZeleniPostaLogo from "../../layout/header/posta_logo_zeleni.png";
import DitNotes from "../../layout/header/mojGrad-ikona-prijedlog.svg";

export const themes = {
  yellow: {
    themeColor: "yellow",
    fontFamily: "Graublau",
    navColor: "black",
    navText: "white",
    navLinkColor: "black",
    cityClass: "location-active",
    lineColor: "warning",
    iconColor: "warning",
    logo: EPostaLogo,
    footer: true,
  },
  blue: {
    themeColor: "blue",
    fontFamily: "Museo",
    navColor: "white",
    navText: "black",
    navLinkColor: "white",
    cityClass: "location-active-blue",
    lineColor: "black",
    iconColor: "info",
    logo: DitLogo,
    footer: false,
  },
  green: {
    themeColor: "primary-light",
    fontFamily: "Poppins",
    navColor: "white",
    navText: "black",
    navLinkColor: "black",
    cityClass: "location-active-blue",
    lineColor: "primary-light",
    iconColor: "info",
    infoDark: "info-dark",
    userIcon: "userIconColor",
    logo: DitNotes,
    footer: true,
    footerVersion: "v2",
  },
  // OLD GREEN - BACKUP
  // green: {
  //   themeColor: "primary-light",
  //   fontFamily: "Graublau",
  //   navColor: "white",
  //   navText: "black",
  //   navLinkColor: "black",
  //   cityClass: "location-active-blue",
  //   lineColor: "primary-light",
  //   iconColor: "primary",
  //   logo: ZeleniPostaLogo,
  //   footer: true,
  //   footerVersion: "v2",
  // },
};

export const ThemeContext = React.createContext(themes.green);
